import {
  SiTypescript,
  SiNextdotjs,
  SiPostgresql,
  SiPrisma,
  SiRedis,
} from "react-icons/si";

export const CardData = [
  {
    heading: "Technologies Used NextJS NodeJS PostgreSQL",
    id: 1,
    img: "/lifemaker.png",
    pName: "LifeMaker",
    pLink: "https://www.lifemaker.space/",
  },
  {
    heading: "Technologies Used NextJS TypeScript RTK Query",
    id: 2,
    img: "/notespitara.png",
    pName: "Notes Pitara",
    pLink: "https://notespitara.com/",
  },
  {
    id: 3,
    heading: "Technologies Used NextJS Resend SEO",
    img: "/sukoonband.png",
    pName: "Sukoon Band",
    pLink: "https://sukoonband.site/",
  },
  {
    id: 4,
    heading: "Technologies Used MERN",
    img: require("../assets/projects/study-notion.png"),
    pName: "Study Notion",
    pLink: "https://study-notion-frontend-phi-mocha.vercel.app/",
  },
];
export const Data = [
  {
    head: "Skills",
    id: 1,
    img: require("../assets/skills/html.png"),
    title: "HTML",
  },
  {
    id: 2,
    img: require("../assets/skills/css.png"),
    title: "CSS",
  },
  {
    id: 3,
    img: require("../assets/skills/javascript.png"),
    title: "JavaScript",
  },
  {
    id: 4,
    icon: SiTypescript,
    color: "#3178c6",
    title: "TypeScript",
  },
  {
    id: 5,
    img: require("../assets/skills/react.png"),
    title: "ReactJS",
  },
  {
    id: 6,
    icon: SiNextdotjs,
    title: "NextJS",
  },
  {
    id: 7,
    img: require("../assets/skills/redux.png"),
    title: "Redux",
  },
  {
    id: 8,
    img: require("../assets/skills/node.png"),
    title: "NodeJS",
  },
  {
    id: 9,
    img: require("../assets/skills/express.png"),
    title: "ExpressJS",
  },
  {
    id: 10,
    icon: SiPostgresql,
    color: "#4169e1",
    title: "PostgreSQL",
  },
  {
    id: 11,
    icon: SiPrisma,
    title: "Prisma",
  },
  {
    id: 12,
    icon: SiRedis,
    color: "#ff4438",
    title: "Redis",
  },
  {
    id: 13,
    img: require("../assets/skills/mongodb.png"),
    title: "MongoDB",
  },
  {
    id: 14,
    img: require("../assets/skills/tailwind.png"),
    title: "Tailwind",
  },
  {
    id: 15,
    img: require("../assets/skills/github.png"),
    title: "Github",
  },
];
